import toast from 'react-hot-toast';
import downloadIcon from '../../imagens/downloadIcon.png'
import { useEffect, useState } from 'react';
import { formataDate, formataDatetime } from '../../util/datas.js'
import { servListarRelatoriosParaDownloadPorTipo, servDownloadArquivoPorId } from '../../servicos/servicosEmRotasPrivadas/download';

function DownloadRelatoriosTabela({ tipoRelatorio }) {

    console.log(' #### Iniciando DownloadRelatoriosTabela ####');

    const [arquivosDownload, setArquivosDownload] = useState(null)

    useEffect(() => {
        if (tipoRelatorio) listarRelatoriosParaDownloadPorTipo();
    }, [tipoRelatorio]);

    const listarRelatoriosParaDownloadPorTipo = async () => {
        try {
            const arquivosDownloadDaApi = await servListarRelatoriosParaDownloadPorTipo(tipoRelatorio)
            setArquivosDownload(arquivosDownloadDaApi)
        } catch (erro) {
            console.log(erro);
            toast.error(erro.message)
        }
    }

    return (
        <div className='d-flex justify-content-center container m-3'>
            <table className='table text-center table-striped'>
                <thead>
                    <tr>
                        <th scope="col" className='p-1'>Data Criação</th>
                        <th scope="col" className='p-1'>Mês Referência</th>
                        <th scope="col" className='p-1'>Mês Inicial</th>
                        <th scope="col" className='p-1'>Mês Final</th>
                        <th scope="col" className='p-1'>Download</th>
                    </tr>
                </thead>
                <tbody >
                    {arquivosDownload && arquivosDownload.map((arquivo) => (
                        <tr key={arquivo.id}>
                            <td className='p-1'>{formataDatetime(arquivo.dataCriacao)}</td>
                            <td className='p-1'>{formataDate(arquivo.mesReferencia)}</td>
                            <td className='p-1'>{formataDate(arquivo.mesInicio)}</td>
                            <td className='p-1'>{formataDate(arquivo.mesFim)}</td>
                            <td className='p-1'>
                                <img className='downloadIcon'
                                    alt='icone de download'
                                    src={downloadIcon}
                                    onClick={() =>
                                        toast.promise(
                                            servDownloadArquivoPorId(arquivo.id),
                                            { loading: 'Carregando...' }
                                        )
                                    }
                                />
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}

export default DownloadRelatoriosTabela
